import {
  AppDispatch,
  getOrganizationListRequest,
  unarchiveOrganization,
  unarchiveOrganizationClear,
  unarchiveOrganizationRequest,
  unarchiveSubject,
  unarchiveSubjectRequest,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

interface SubjectUnArchiveCardProps {
  name: string;
  onCancel: () => void;
  worker: any;
}

const SubjectUnArchiveCard: React.FC<SubjectUnArchiveCardProps> = ({
  worker,
  name,
  onCancel,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { result: unArchiveResult, loading: unArchiveLoading } =
    useSelector(unarchiveSubject);

  useEffect(() => {
    if (unArchiveResult?.status === "success") {
      onCancel();
    }
  }, [unArchiveResult?.status]);

  const onUnArchiveClick = () => {
    dispatch(
      unarchiveSubjectRequest({
        id: worker?.id || "",
      })
    );
  };

  return (
    <div>
      <span>{`Are you sure you want to Un Archive the "${name}"?`}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type="primary"
          onClick={onUnArchiveClick}
          loading={unArchiveLoading}
        >
          {t("un_archive")}
        </Button>
      </div>
    </div>
  );
};

export default SubjectUnArchiveCard;
